import { render, staticRenderFns } from "./JcResDistanceOfRes.vue?vue&type=template&id=74e45bba"
import script from "./JcResDistanceOfRes.vue?vue&type=script&lang=js"
export * from "./JcResDistanceOfRes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports